import { tagsListActionTypes as actions } from '~constants/actionTypes';
import { fetch } from '~actions/shared';
import { sortDirectionMapping, sortByMapping } from '~constants';
import endpoints from '~settings/endpoints';
import { formatSimpleParams } from '~helpers/params';
import * as queries from '~settings/queries';

export const setTagsList = payload => ({
  type: actions.SET_LIST,
  payload: payload.tags,
});

export const getTagsList = (params, callback) => dispatch => {
  const simpleParams = formatSimpleParams(
    {
      pageNumber: 1,
      pageSize: 10,
      sortBy: sortByMapping.updatedAt,
      sortDirection: sortDirectionMapping.descend,
      propertyId: null,
      status: null,
      name: null,
      types: null,
    },
    params,
  );
  const query = queries.getTagsList(simpleParams);

  fetch({
    dispatch,
    endpoint: endpoints.graphql.url(),
    params: query,
    communicationType: actions.LIST_CS,
    successAction: setTagsList,
    onSuccess: callback,
  });
};

export const deleteTag = (params, callback) => dispatch => {
  const simpleParams = formatSimpleParams(
    {
      id: null,
    },
    params,
  );
  const query = queries.deleteTag(simpleParams);

  fetch({
    dispatch,
    endpoint: endpoints.graphql.url(),
    params: query,
    communicationType: actions.LIST_CS,
    onSuccess: callback,
  });
};
